import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TreeNode from '../../../TreeNode/TreeNode';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import groupBy from 'lodash/groupBy';
import noop from 'lodash/noop';
import { AllArticlesPage, ArticleLink, CategoryRow } from './ZendeskAllArticles.styles';

// TODO - duplicate functionality of ZendeskAllArticles and ZendeskArticleSearchComponent should be merged later
class ZendeskAllArticles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSections: {},
    };
  }

  onSectionClick(getHelpCenterArticlesBySection, zendesk, sectionId, simplrAccountId) {
    const { selectedToolDomains } = this.props;
    const openSections = Object.assign({}, this.state.openSections);
    openSections[sectionId] = !openSections[sectionId];
    this.setState({
      openSections: openSections,
    });

    const articlesForSection = filter(zendesk.articles, (article) => article.section_id === sectionId);
    const haveArticlesForSection = articlesForSection && articlesForSection.length;
    if (openSections[sectionId] && !haveArticlesForSection) {
      getHelpCenterArticlesBySection(selectedToolDomains.zendesk, sectionId, simplrAccountId);
    }
  }

  render() {
    const { zendesk, getHelpCenterArticlesBySection, setCurrentPage, simplrAccountId } = this.props;

    const categories = zendesk.categories;
    const sections = zendesk.sections;
    const articles = zendesk.articles;

    const sortedCategories = sortBy(categories, 'name');
    const sectionsByCategory = groupBy(sections, 'category_id');
    const articlesBySection = groupBy(articles, 'section_id');

    const categoryList = sortedCategories.map((category, categoryIndex) => {
      const sortedSections = sortBy(sectionsByCategory[category.id], 'name');
      const sectionList = sortedSections.map((section, sectionIndex) => {
        const sectionId = section.id;
        const sectionIsOpen = this.state.openSections[sectionId] || false;
        const sectionArticles = articlesBySection[sectionId];
        const sectionArticleLinks =
          sectionIsOpen &&
          sectionArticles &&
          sectionArticles.map((article, articleIndex) => {
            return (
              <div key={article.name} className="row">
                <div className="col-xs-12">
                  <ArticleLink onClick={() => setCurrentPage('articleDetails', article)}>{article.name}</ArticleLink>
                </div>
              </div>
            );
          });

        return (
          <div key={section.name}>
            <div className="row">
              <TreeNode
                label={section.name}
                onClickFunction={() =>
                  this.onSectionClick(getHelpCenterArticlesBySection, zendesk, sectionId, simplrAccountId)
                }
                isOpen={sectionIsOpen}
              />
            </div>
            {sectionArticleLinks}
          </div>
        );
      });

      return (
        <div key={category.name}>
          <CategoryRow className="row">
            <div className="col-xs-12">{category.name}</div>
          </CategoryRow>
          {sectionList}
        </div>
      );
    });

    return this.props.knowledgeBaseFolderUrl === undefined ? (
      <AllArticlesPage>{categoryList}</AllArticlesPage>
    ) : (
      <AllArticlesPage>
        <div className="row">
          <a href={this.props.knowledgeBaseFolderUrl} target="_blank" rel="noopener noreferrer">
            <TreeNode label="Knowledge Base" onClickFunction={noop} isOpen={false} />
          </a>
        </div>
        {categoryList}
      </AllArticlesPage>
    );
  }
}

ZendeskAllArticles.propTypes = {
  zendesk: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.object).isRequired,
    sections: PropTypes.arrayOf(PropTypes.object).isRequired,
    articles: PropTypes.arrayOf(PropTypes.object),
  }),
  getHelpCenterArticlesBySection: PropTypes.func.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  selectedToolDomains: PropTypes.shape({
    zendesk: PropTypes.string.isRequired,
  }).isRequired,
  knowledgeBaseFolderUrl: PropTypes.string,
  simplrAccountId: PropTypes.string.isRequired,
};

export default ZendeskAllArticles;
